import * as React from "react";
import { Routes, Route } from "react-router";

import SessionRecapPage from "../SessionRecap/SessionRecapPage";

import Pair from "./Pair";

export default function Sessions(): React.JSX.Element {
    return (
        <Routes>
            <Route path="pair/*" element={<Pair />} />
            <Route path=":id/recap" element={<SessionRecapPage />} />
        </Routes>
    );
}
